import { SocietePatrimoineHierarchie, SocieteTerritoire } from '@get/api-interfaces';

export function comparePatrimoineHierarchieFn(a: SocietePatrimoineHierarchie, b: SocietePatrimoineHierarchie): boolean {
  return a?.idSocietePatrimoineHierarchie === b?.idSocietePatrimoineHierarchie;
}

export function compareTerritoireFn(a: SocieteTerritoire, b: SocieteTerritoire): boolean {
  return a?.idSocieteTerritoire === b?.idSocieteTerritoire;
}
